module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/gems/broken-mask-180.jpg"+" 180w",
        images: [{path: __webpack_public_path__ + "assets/images/gems/broken-mask-180.jpg",width: 180,height: 180}],
        src: __webpack_public_path__ + "assets/images/gems/broken-mask-180.jpg",
        toString: function(){return __webpack_public_path__ + "assets/images/gems/broken-mask-180.jpg"},
        
        width: 180,
        height: 180
      }